import { Box, Button } from '@mui/material';
import Loading from 'components/common/Loading';
import { func, object, string } from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import messages from 'store/app/entities/messages/action';
import useConnecting from 'utils/useConnecting';
import useSendAction from 'utils/useSendAction';

const styleSx = {
  primary: {
    button: theme => ({
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    }),
    text: theme => ({
      color: theme.palette.white,
    }),
  },
  secondary: {
    button: theme => ({
      borderColor: theme.palette.tertiary.main,
    }),
    text: theme => ({
      color: theme.palette.tertiary.main,
    }),
  },
  danger: {
    button: theme => ({
      borderColor: theme.palette.danger,
    }),
    text: theme => ({
      color: theme.palette.danger,
    }),
  },
};

const BlockButton = ({ button, msgId, blockId, updateMessage }) => {
  const onResponseOk = msg => {
    updateMessage(msg);
  };
  const [disabled, sendButtonAction] = useSendAction(button, msgId, blockId, onResponseOk);
  const [hidden] = useState(false);
  const connecting = useConnecting();

  const style = button.style || 'primary';
  const variantStyles = styleSx[style] || styleSx.primary;
  return hidden ? null : (
    <div
      key={`button-${button.actionId}`}
      style={{
        flex: '1 0 auto',
        flexDirection: 'column',
        justifyContent: 'center',
        marginBottom: 0,
      }}
    >
      <Button
        disabled={disabled || connecting || button.disabled}
        variant={style === 'primary' ? 'contained' : 'outlined'}
        color={style === 'primary' ? 'primary' : 'secondary'}
        sx={[
          {
            alignItems: 'center',
            padding: '10px',
            flex: 1,
          },
          (disabled || button.disabled) && { opacity: 0.4 },
          variantStyles.button,
        ]}
        onClick={() => sendButtonAction()}
      >
        {connecting ? <Loading size={30} /> : <Box sx={variantStyles.text}>{button.text.text}</Box>}
      </Button>
    </div>
  );
};

BlockButton.propTypes = {
  button: object.isRequired,
  msgId: string.isRequired,
  blockId: string.isRequired,
  updateMessage: func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  updateMessage: messages.updateSuccess,
};
export default connect(mapStateToProps, mapDispatchToProps)(BlockButton);
